import m from 'mithril'


export default {
  view(vnode) {
    return m('.access-dialog',
      m('.body-content.padding.mw-med',
        m('h1', "Modify Access")
      )
    )
  }
}
